import { getOrderContext } from 'contexts/order';
import React from 'react';
import Cardbox from '../Cardbox';
import FlexDivider from '../FlexDivider';

const Product = ({ data, type }) => {
    const { menus, setMenus } = React.useContext(getOrderContext)
    const handleAddMenu = (product) => {
        setMenus([...menus, { ...product }])
    }
    return (
        <FlexDivider>
            {data.map((product) => {
                return product.definitions.map(def => (
                    <Cardbox
                        name={product.name}
                        price={def.price ?? def.defaultPrice}
                        key={def.masterName}
                        img={type?.toLowerCase()}
                        imgUrl={product?.imageUrl}
                        data={def}
                        onSelect={handleAddMenu}
                        desc={def.description}

                    />
                ))
            })}
        </FlexDivider>
    );
};

export default Product;
